var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 14",
    style: {
      enableBackground: "new 0 0 16 14"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.gas-svg{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gas-svg",
    d: "M9.5,13c0,0.4,0.3,0.8,0.8,0.8S11,13.4,11,13H9.5z M1,13c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8H1z M3.8,1.5 h4.5V0H3.8V1.5z M9.5,2.8V13H11V2.8H9.5z M2.5,13V2.8H1V13H2.5z M8.2,1.5c0.7,0,1.2,0.6,1.2,1.2H11C11,1.2,9.8,0,8.2,0V1.5z M3.8,0 C2.2,0,1,1.2,1,2.8h1.5c0-0.7,0.6-1.2,1.2-1.2V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gas-svg",
    d: "M4.8,3.8V3C4.3,3,4,3.3,4,3.8H4.8z M7.2,3.8H8C8,3.3,7.7,3,7.2,3V3.8z M7.2,7.2V8C7.7,8,8,7.7,8,7.2H7.2z  M4.8,7.2H4C4,7.7,4.3,8,4.8,8V7.2z M4.8,4.5h2.5V3H4.8V4.5z M6.5,3.8v3.5H8V3.8H6.5z M5.5,7.2V3.8H4v3.5H5.5z M4.8,8h2.5V6.5H4.8V8 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "gas-svg",
    d: "M0.8,12.5c-0.4,0-0.8,0.3-0.8,0.8S0.3,14,0.8,14V12.5z M11.2,14c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8V14z  M0.8,14h10.5v-1.5H0.8V14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "gas-svg",
    d: "M10.5,9.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8V9.2z M13.5,3.7l-0.6-0.5L13.5,3.7z M15.8,2.2 c0.3-0.3,0.2-0.8-0.1-1.1c-0.3-0.3-0.8-0.2-1.1,0.1L15.8,2.2z M10.5,10.8h0.8V9.2h-0.8V10.8z M14,8V4.4h-1.5V8H14z M14.1,4.2l1.7-2 l-1.1-1l-1.7,2L14.1,4.2z M14,4.4c0-0.1,0-0.1,0.1-0.2l-1.1-1c-0.3,0.3-0.4,0.7-0.4,1.2H14z M11.2,10.8c1.5,0,2.8-1.2,2.8-2.8h-1.5 c0,0.7-0.6,1.2-1.2,1.2V10.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.819cb3f8afa32a58d1866bb4fb0096a4.svg";
export { ForwardRef as ReactComponent };